import React, { useCallback, useEffect, useState } from "react";
import { getPublicUsers } from "../../api/api";
import "./AdminPanel.css";

function PublicUserListAdminPanel() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Role check for superadmin only
  const role = localStorage.getItem("role");

  const fetchUsers = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const res = await getPublicUsers();
      const list = Array.isArray(res?.data) ? res.data : (res?.data?.users || []);
      setUsers(list);
    } catch (err) {
      setUsers([]);
      setError(err?.response?.data?.message || "Failed to load public users.");
    } finally {
      setLoading(false);
    }
  }, []);

  // auto fetch when page opens
  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  if (role !== "superadmin") {
    return (
      <div style={{ color: "red", textAlign: "center", marginTop: "2rem" }}>
        Access denied: Superadmin only
      </div>
    );
  }

  // Calculate total logged-in users using backend isLoggedIn field
  const loggedInCount = users.filter((u) => u.isLoggedIn).length;

  return (
    <div className="resource-admin-panel resource-admin-panel--emerald">
      <div className="resource-admin-panel__header">
        <div>
          <h2 className="resource-admin-panel__heading">👥 Public User List Admin Panel</h2>
          <p className="resource-admin-panel__subtext">
            Total Registered Users: {users.length}
            <br />
            Total Logged In Users: {loggedInCount}
          </p>
          {error ? <p style={{ color: "#ff6b6b", marginTop: 6 }}>{error}</p> : null}
        </div>
        <div className="resource-admin-panel__pill">Users</div>
        <button
          style={{
            marginLeft: 8,
            padding: "4px 10px",
            borderRadius: 6,
            background: "#223",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            fontWeight: 600,
            width: "auto",
            minWidth: 0,
            display: "inline-block",
          }}
          onClick={fetchUsers}
          disabled={loading}
        >
          {loading ? "Refreshing..." : "Refresh"}
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : users.length === 0 ? (
        <p>No public users found.</p>
      ) : (
        <div
          className="resource-admin-panel__list"
          style={{ maxHeight: "900px", overflowY: users.length > 50 ? "auto" : "visible" }}
        >
          <table className="user-table" style={{ width: "100%", borderCollapse: "collapse", marginTop: 16 }}>
            <thead>
              <tr className="user-table-header">
                <th>Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Password</th>
                <th>Registered</th>
                <th>Login Status</th>
              </tr>
            </thead>
            <tbody>
              {users.slice(0, 50).map((user, idx) => (
                <tr key={user._id || idx} className={idx % 2 === 0 ? "user-table-row-even" : "user-table-row-odd"}>
                  <td>{user.name || user.email || "No Name"}</td>
                  <td>{user.email || "-"}</td>
                  <td>{user.mobile || "-"}</td>
                  <td>{user.password ? "********" : "-"}</td>
                  <td>{user.createdAt ? new Date(user.createdAt).toLocaleString() : "-"}</td>
                  <td style={{ color: user.isLoggedIn ? "#0f0" : "#f44", fontWeight: "bold" }}>
                    {user.isLoggedIn ? "Logged In" : "Not Logged In"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default PublicUserListAdminPanel;